export const PERMISSION_PRODUCTS = {
  CREATE: 'ProductsModule.create',
  VIEW: 'ProductsModule.view',
  UPDATE: 'ProductsModule.update',
  DELETE: 'ProductsModule.delete',
};
